<template>
  <div 
    class="attachment_container"
    element-loading-text="文件上传中..."
    v-loading.fullscreen.lock="fileUploading"
  >
    <div class="page_middle_row" style="min-height: 40px;">
      <div
        class="attachment_page_middle_row_td page_middle_row_td_file page_middle_row_td_textarea"
        :class="{ 'align-center': !files.length && !showUpload }"
      >
        <div class="page_middle_row_key" v-if="required.title">
          <span class="page_middle_row_key_required" v-if="required.isRequired"
            >*</span
          >{{ required.title }}
        </div>
        <div
          class="page_middle_row_value color999"
          v-if="!files.length && !showUpload"
        >
          暂无
        </div>
        <div class="page_middle_row_value" v-else>
          <div
            class="page_middle_row_td_file_item"
            v-for="(item, index) in files"
            :key="item"
          >
            <div
              :style="isLinkWidth > 0? `flex: 1 0 ${isLinkWidth}px` : ''"
              class="page_middle_row_td_file_name"
              :class="{ attachment_a_link: isLink }"
            >
              <span v-if="!isLink">{{ getFileName(files[index]) }}</span>
              <span
                class="attachment_link"
                v-else
                @click="addBlankPath(files[index])"
                >{{ getFileName(files[index]) }}</span
              >
            </div>
            <div style="display: flex;flex-direction: column;">
              <div>
                <el-button
                  size="small"
                  type="primary"
                  class="file_upload_button"
                  v-if="showUpload"
                  @click="replaceFile(index)"
                  >替换</el-button
                >
              </div>
              <div style="margin-top: 2vw;">
                <el-button
                  type="danger"
                  size="small"
                  class="file_upload_button"
                  v-if="showUpload"
                  @click="deleteFile(index)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <el-button
            size="small"
            class="page_middle_row_td_upload"
            :class="{ w150: getButtonName() !== defaultButton }"
            v-if="showUpload"
            @click="selectFile"
            >
            <template #default>
              <div style="display: flex;justify-content: center;">
                <div style="position: relative;">
                  <el-icon><UploadFilled /></el-icon>&nbsp;&nbsp;{{ getButtonName() }}
                </div>
              </div>
            </template>
          </el-button
          >
        </div>
      </div>
    </div>
    <input
      type="file"
      multiple
      v-show="false"
      @change="changeFile"
      v-if="resetFile"
      ref="selectFile"
    />
  </div>
</template>
<script>
import upload from "@/common/uploads";
import { UploadFilled } from '@element-plus/icons'
export default {
  name: "attachment",
  props: {
    type: {
      type: String,
      default: "",
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    isLinkWidth: {
      type: Number,
      default: 0,
    },
    showUpload: {
      type: Boolean,
      default: true,
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    required: {
      type: Object,
      default: () => {
        return {
          isRequired: false,
          title: "附件:",
        };
      },
    },
    maxSize: {
      type: Number,
      default: 0,
    },
    files: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    UploadFilled
  },
  data: () => {
    return {
      fileIndex: null,
      selectUpload: true,
      resetFile: true,
      defaultButton: "上传",
      fileUploading:false,
      config: {
        allowType: [
          "jpeg",
          "jpg",
          "png",
          "xls",
          "xlsx",
          "doc",
          "docx",
          "ppt",
          "pptx",
          "pdf",
          "txt",
          "mp3",
          "mp4",
          "rar",
          "zip",
          "ai",
        ],
      },
    };
  },

  methods: {
    addBlankPath(url) {
      if (!url) return;
      if(url.includes("&f_name=")){
        url = encodeURI(url);
        this.$tools.downLoadFile(url);
      }else{
        this.$tools.aTagDownLoad(url);
      }
    },
    getCurFileName(name) {
      return name.substring(0, name.lastIndexOf("."));
    },
    getFileName(v) {
      return v.substring(v.lastIndexOf("/") + 1);
    },
    getButtonName() {
      let buttonName =
        this.$route.query.importBestUploadBtnText || this.defaultButton;
      return this.files.length > 1 ? this.defaultButton : buttonName;
    },
    selectFile() {
      this.selectUpload = true;
      this.fileIndex = 0;
      this.$refs.selectFile.click();
    },
    replaceFile(index) {
      // let params = {
      //   ...this.params,
      //   index
      // }
      this.selectUpload = false;
      this.fileIndex = index+1;
      this.$refs.selectFile.click();
      // this.$emit("replaceFile",params)
    },
    deleteFile(index) {
      let params = {
        ...this.params,
        index,
      };
      this.$confirm("您确定要删除该文件吗？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass",
        cancelButtonClass: "cancelButtonClass",
        type: "error",
      })
        .then(() => {
          this.$emit("deleteFile", params);
        })
        .catch(() => {});
    },
    async changeFile(e) {
      let files = e.target.files;
      this.resetFile = false;
      let countSize = this.files.length + files.length > this.maxSize;
      if (this.maxSize > 0 && countSize > this.maxSize) {
        this.$tips.error({ text: `您多选${countSize - this.maxSize}` });
        this.$nextTick(() => {
          this.resetFile = true;
        });
        return;
      }
      let allowType = "all";
      this.fileUploading = true;
      let data = await upload.uploadFile(files, allowType, "files", "", {
        project: "erp",
        type: this.type || this.$config.types.files.attachment,
      });
      this.$nextTick(() => {
        this.resetFile = true;
      });
      if (!data) {
        // loadingItem.close();
        return;
      }
      try {
        await this.checkFileIsRepeat(data.data);
        // loadingItem.close();
        let params = {
          ...this.params,
          data: data,
          index:this.fileIndex,
        };
        // if (this.fileIndex || this.fileIndex === 0) {
        //   this.$emit("replaceFile", params, this.fileIndex);
        //   return;
        // }
        this.$emit("changeFile", params);
      } catch (error) {
        console.log(error)
        // loadingItem.close();
      }
      this.fileUploading = false;
    },
    checkFileIsRepeat(newFiles){
      let files = this.files.concat(newFiles);
      return new Promise((resolve, reject) => {
        this.$axios.post(this.$urls.upload.check_files,{files:files}).then(()=>{
          resolve({isRepeat:false});
        }).catch((err)=>{
          reject({isRepeat:true,err:err})
        })
      })
    }
  },
};
</script>
<style>
.attachment_container{
  width: 100%;
}
.page_middle_row_td_file_name {
  flex: 1 0 0;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  border-radius: 2px;
  padding: 2vw 4vw;
  word-break: break-all;
}
.page_middle_row_td_file_item .file_upload_button {
  margin-left: 2vw !important;
  min-height: 2vw !important;
  padding: 10px 10px !important;
  border-radius: 5px !important;
  font-size: 26px !important;
}
.align-center {
  align-items: center;
}
.color999 {
  color: #999;
}
.attachment_a_link {
  position: relative;
  z-index: 10;
}
.attachment_link {
  color: #4399e7;
  cursor: pointer;
}
.attachment_container a:hover,
.attachment_container a:link,
.attachment_container a:active,
.attachment_container a:visited {
  color: #2e87f0;
}
.w150 {
  width: 150px !important;
}
.page_middle_row_td_upload {
    width: 100% !important;
    font-size: 26px !important;
}
.page_middle_row_td_upload i{
  font-size: 26px !important;
  position: absolute;
  top: 0.033vw;
  left: -2.733vw;
}
.attachment_container .el-button--default{
  border: 1px solid var(--el-color-primary) !important;
  color: var(--el-color-primary) !important;
  font-weight: bold !important;
  background-color:#fff !important;
  border-radius: var(--el-border-radius-base);
}
.attachment_container .page_middle_row{
  margin-bottom: 0;
  align-items: center !important;
  justify-content: flex-start;
}
.attachment_page_middle_row_td{
  display: flex;
  /* width: 100%; */
  flex: 1 0 0;
}
.page_middle_row_td_file .el-input,
.page_middle_row_td_file .el-select {
  flex: 1 0 0;
}

.page_middle_row_td_file .page_middle_row_key {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.page_middle_row_td_file .page_middle_row_value {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
}
</style>
